import React from "react"
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts"
import { CHART_COLORS, LOSS_REASON_LABELS, formatINR } from "../constants"

export function WinLossDonut({ totals }) {
  if (!totals) return null

  const data = [
    { name: "Won", value: totals.won, fill: CHART_COLORS.won },
    { name: "Lost", value: totals.lost, fill: CHART_COLORS.lost },
  ].filter((d) => d.value > 0)

  if (!data.length) return null

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="mb-3 text-[13px] font-medium text-slate-700">Win vs Loss</div>
      <ResponsiveContainer width="100%" height={220}>
        <PieChart>
          <Pie data={data} innerRadius={55} outerRadius={85} dataKey="value" nameKey="name">
            {data.map((d, i) => (
              <Cell key={i} fill={d.fill} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => [value, "Deals"]} />
          <Legend verticalAlign="bottom" height={32} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}

export function LossReasonsTable({ reasons = [] }) {
  if (!reasons.length) return null

  return (
    <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
      <div className="px-4 py-3 text-[13px] font-medium text-slate-700">Loss Reasons</div>
      <table className="w-full text-[13px]">
        <thead className="bg-slate-50 text-left text-slate-500">
          <tr>
            <th className="px-4 py-2.5 font-medium">Reason</th>
            <th className="px-4 py-2.5 font-medium text-right">Count</th>
            <th className="px-4 py-2.5 font-medium text-right">Value Lost</th>
          </tr>
        </thead>
        <tbody>
          {reasons.map((r) => (
            <tr key={r.reason} className="border-t border-slate-100">
              <td className="px-4 py-2.5 text-slate-900">
                {LOSS_REASON_LABELS[r.reason] || r.label}
              </td>
              <td className="px-4 py-2.5 text-right">{r.count}</td>
              <td className="px-4 py-2.5 text-right">{formatINR(r.value_lost)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
